import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { selectAll } from "lib/SelectAll"
import { SummaryDataChanged } from "event-definitions"
import { convertToMinMaxNumber } from "lib/number"
import { UOM_TO_NAME } from "routes/schedule/lib/uom-to-input"
import { Bound } from "lib/@components/binding/Bound"
import { RegimeDraftLockTooltip } from "../regime-draft-locking/regime-draft-lock-tooltip"

const MAX_UNIT = 25000

export function UOM({ uom }) {
    const [number] = useBoundValue(uom, 1)

    return (
        <Bound uom={uom}>
            <RegimeDraftLockTooltip>
                <BoundTextField
                    autoFocus
                    onFocus={selectAll}
                    onChanged={() => SummaryDataChanged.raiseOnce()}
                    key={uom}
                    sx={{ my: 0.5 }}
                    transformOut={convertToMinMaxNumber(0, MAX_UNIT)}
                    helperText={number >= MAX_UNIT ? `Maximum value is ${MAX_UNIT}` : ""}
                    field={uom}
                    label={UOM_TO_NAME[uom]}
                    default={1}
                    data-cy="no-of-assets"
                    transformOutOnBlur={transformInput}
                    updateValueOnBlur={true}
                />
            </RegimeDraftLockTooltip>
        </Bound>
    )

    function transformInput(v) {
        if (!v || v?.toString().startsWith(".") || v?.toString().startsWith("-")) {
            return 1
        }
        return parseInt(v)
    }
}
